{
  "fr": {
    "project": {
      "actions": {
        "activate": "Activer",
        "addProjectMaintainer": "Ajouter mainteneur",
        "add_as_partner": "Ajouter comme partenaire",
        "add_as_partner_description": "Voulez-vous ajouter {partner} comme partenaire à ce projet?",
        "add_project_partner": "Ajouter un partenaire de projet",
        "additional_information": "Informations Complémentaires",
        "changeProjectLogin": "Changez l'image du projet",
        "changeProjectLogo": "Changer le logo du projet",
        "deactivate": "Désactiver",
        "edit": "Modifier",
        "finishRequest": "Envoyer la demande",
        "follow": "Suivre",
        "giveAccess": "Donner accès",
        "maintainerAdd": "Ajouter un mainteneur",
        "maintainerAddDescription": "Êtes-vous sûr de vouloir accorder à {maintainer} l'accès à ce projet?",
        "maintainerRemove": "Supprimer le mainteneur du projet",
        "maintainerRemoveDescription": "Êtes-vous sûr de vouloir révoquer l'accès à ce projet pour {maintainer}?",
        "new": "Nouveau Projet",
        "next": "Suivant",
        "remove_partner": "Supprimer {partenaire}",
        "remove_project_partner": "Supprimer le partenaire du projet",
        "remove_project_partner_description": "Êtes-vous sûr de vouloir supprimer {partner} des partenaires du projet?",
        "selectOption": "Sélectionner option",
        "selectTemplate": "Sélectionner un modèle de projet",
        "submit": "Créer un projet",
        "unFollow": "Non suivi"
      },
      "attributes": {
        "address": "Adresse",
        "currency": "Devise",
        "delivery_date_actual": "Date de fin prévue",
        "delivery_date_contractual": "Date de fin contractuelle",
        "description": "Description",
        "internal_note": "Note interne",
        "measurement": "Unité de mesure",
        "name": "Nom",
        "picture_login_url": "Image du Projet",
        "picture_logo_url": "Logo du projet",
        "quotity_total": "Quotité totale",
        "skip_building": "Aucune Bâtiment?",
        "skip_lot": "Aucune Lot?",
        "skip_phase": "Aucune phase?",
        "skip_unit": "Cacher l'unité (projet avec une unité)",
        "start_date": "Date de début",
        "units_count": "Nombre d'Unités Créées",
        "units_count_max": "Nombre maximum d'unités",
        "vat_percentage": "TVA %",
        "website_url": "Site Web URL"
      },
      "errors": {
        "capacity": {
          "cant_have_more_units": "Capacité atteinte, merci de nous contacter."
        }
      },
      "import": {
        "add": "+ Ajouter",
        "add_instead": "En fait je veux ajouter des {levels}",
        "building": "imeuble",
        "buildings": "bâtiments",
        "changed_mind": "Sauter ce niveau",
        "create_new": "Quel est le nom du {type}",
        "download_template": "Télécharger le modèle d'importation",
        "drop_or_upload": "Déposez le modèle ici ou cliquez pour télécharger",
        "error_line": "Erreur en ligne",
        "fill_space_info": "Remplir le modèle avec les informations sur l'espace",
        "fill_unit_info": "Remplir le modèle avec les informations sur l'unité",
        "fix_file_upload": "Veuillez résoudre les problèmes et télécharger à nouveau le fichier.</br>Les unités existantes ne seront pas supprimées, mais seront mises à jour si quelque chose a changé dans le fichier de cette unité depuis le dernier téléchargement.",
        "fix_file_upload_space": "Veuillez résoudre les problèmes et télécharger à nouveau le fichier.</br>Les espaces existants ne seront pas supprimés, mais seront mis à jour si quelque chose a changé dans le fichier pour cette espace depuis le dernier téléchargement.",
        "for": "pour",
        "import_column_title": "Voulez-vous ajouter {column_type}?",
        "import_partial_success": "Importation partiellement réussie. Voici les erreurs restantes :",
        "import_spaces": "Importer des espaces",
        "import_units": "Importer des unités pour",
        "lot": "parcelle",
        "lots": "parcelles",
        "no": "non",
        "noLevels": "Pas de {levels}",
        "phase": "phase",
        "phases": "étapes",
        "plot": "parcelle",
        "select_level_above": "Sélectionnez un {level} pour continuer",
        "start_upload": "Commence le téléchargement",
        "step": "Marcher",
        "unit_info": "Vous pourrez importer des unités une fois le projet créé",
        "unit_limit": "Vous souhaitez importer plus d'unités que vous n'êtes autorisé à le faire. Veuillez supprimer l'unité {exceeded_by} ou nous demander d'augmenter votre nombre d'unités autorisées",
        "units": "unités",
        "upload_filled_template": "Télécharger le modèle rempli",
        "upload_new_file": "Télécharger un nouveau fichier",
        "upload_spaces": "Télécharger des espaces",
        "upload_units": "Importer des unités",
        "uploaded_file": "Fichier téléchargé",
        "validations_failed": "Certaines validations ont échoué",
        "yes": "oui"
      },
      "labels": {
        "activate": "Projet Activeer",
        "checkLevels": "Vérifiez les niveaux que vous souhaitez ajouter:",
        "companyInfo": "Information d'entreprise",
        "companyNameTitle": "Nom de l'entreprise",
        "congratulationsNewProject": "Félicitations pour votre nouveau projet",
        "copyFromTemplate": "Copier le modèle de projet (optionnel)",
        "customer_can_create_issue": "Le client peut créer un point",
        "customersCanLogIn": "Les clients de ce projet peuvent se connecter avec",
        "deactivate": "Projet Deactiveer",
        "deactivated": "Désactivée",
        "deactivatedProjects": "Projets Désactivés",
        "download_export": "Télécharger votre fichier",
        "downloading_export": "Téléchargement en cours",
        "endsOn": "Se termine sur le {enddate}",
        "export_expiration": "Vos données d'exportation sont prêtes à être téléchargées. Elles resteront disponibles jusqu'au {time}",
        "export_explanation": "Recevez une exportation de toutes vos données, y compris les conversations et les documents.",
        "export_failed": "Échec de l'exportation",
        "export_file": "Exporter votre dossier",
        "export_notification_snack": "La collecte de votre dossier peut prendre quelques minutes. Vous recevrez une notification lorsqu'elle sera prête à être téléchargé.",
        "export_prepared": "Vos données d'exportation seront prêtes à être télécharger tout de suite.",
        "export_preparing": "En cours de préparation",
        "filterProject": "Sélectionnez un projet",
        "finalSteps": "Etapes finales",
        "follow": "Suivez {project} pour recevoir des notifications.",
        "followedProjects": "Mes Projets",
        "following": "Je suis",
        "general": "Général",
        "importContacts": "Oui, je souhaite importer des contacts clients",
        "importInformationSubtitle": "Au lieu d'ajouter des espaces et des contacts un par un, nous pouvons vous aider à importer un fichier CSV. Cochez les cases ci-dessous et un membre de l'équipe Ziggu vous contactera.",
        "importInformationTitle": "Importer des informations?",
        "importSpaces": "Oui, je souhaite importer des places de parking et de stockage",
        "importUnits": "Oui, je souhaite importer des unités et leurs informations",
        "included": "Inclus",
        "internal": "Interne",
        "invoice_subtitle": "Nous n'enverrons une facture que si nécessaire, par ex. lorsque vous n'avez plus d'unités dans votre colis.",
        "invoice_title": "A quelle adresse e-mail pouvons-nous envoyer nos factures ?",
        "isTemplateProject": "Il s'agit d'un projet modèle",
        "levelBuildingExplainer": "Sélectionnez cette option si vous avez plusieurs unités à l'intérieur d'un ou de plusieurs bâtiments.",
        "levelPhaseExplainer": "Sélectionnez cette option si votre projet est construit en différentes phases, étalées dans le temps.",
        "levelPlotExplainer": "Sélectionnez cette option si votre projet se compose de plusieurs parcelles.",
        "levelProjectExplainer": "Votre projet est l'élément le plus important et il est essentiel pour démarrer.",
        "levelUnitExplainer": "L'unité est le plus petit élément de construction. C'est la maison ou l'appartement que vous construisez pour vos clients.",
        "levels": "Structure du projet",
        "limitReached": "Limite du projet atteinte",
        "multiUnits": "Unités multiples",
        "nameTitle": "Le nom du projet?",
        "newProjectTitle": "Nous allons créer notre nouveau projet !",
        "noAccess": "Vous n'avez pas accès à ce projet",
        "noFollowedProjects": "Cliquez sur l'icône de notification pour suivre un projet.",
        "noProjects": "Aucun projet n'a été trouvé",
        "optional_information": "Informations facultatives",
        "optional_information_subtitle": "Y a-t-il autre chose que vous aimeriez partager avec nous?",
        "otherProjects": "Autres Projets",
        "outOfProjects": "Il semble que votre paquet soit à court de projets actifs.",
        "outOfProjectsContact": "Contactez Ziggu pour augmenter votre forfait et continuer à créer des projets.",
        "partner_invitation_notice": "{partner} n'a pas encore été invité. Une invitation sera envoyée lorsque {partner} sera ajouté aux partenaires du projet.",
        "pendingProjects": "{first_project_name} a été demandé et est actuellement configuré par Ziggu | {count} projets ont été demandés et sont actuellement mis en place par Ziggu",
        "permission_partner_project": "Un partenaire pour partager facilement avec lui les documents et propositions de ce projet.",
        "permissionsOwnerOnly": "Seuls les collègues avec le rôle Propriétaire peuvent ajouter de nouveaux Mainteneurs de projet.",
        "permissionsRoleMaintainer": "Une collègue avec accès à ce projet",
        "project": "Projet {project}",
        "projectBranding": "L'image de marque du projet",
        "projectIsDeactivated": "Ce projet est désactivé",
        "projectMaintainers": "Mainteneurs du projet",
        "projectName": "Nom du projet",
        "projectStructure": "Structure du projet",
        "projectStructureSubtitle": "Vous avez maintenant la possibilité d'ajouter 3 niveaux supplémentaires pour mieux organiser vos unités.</br>Passons en revue chacun d'eux, étape par étape.",
        "projectStructureSubtitleOld": "La structure du projet est définie une fois au démarrage du projet.",
        "project_label": "Projet",
        "project_partners": "Partenaires du projet",
        "projects": "Projets",
        "remove_project_partner_prohibited": "{partner} est ajouté aux décisions de ce projet et ne peut pas être supprimé des partenaires du projet.",
        "remove_project_partner_prohibited_label": "Le partenaire du projet ne peut pas être supprimé",
        "searchProject": "Rechercher un projet",
        "searchProjects": "Rechercher des projets",
        "selectATemplateProject": "Sélectionner un modèle de projet",
        "selected": "Sélectionné",
        "showProject": "Montrer le projet",
        "singleUnit": "Unité unique",
        "spaces": "Espaces",
        "startsOn": "Commence le {startdate}",
        "step1Info": "Passons en revue quelques détails pour vous aider à démarrer.",
        "step1Title": "Félicitations pour votre nouveau projet !",
        "step2Info": "A quelle entreprise pouvons-nous adresser la facture?",
        "step2Title": "Détails de facturation",
        "step3Title": "Besoin de niveaux intermédiaires?",
        "step4Info": "Que se passe-t-il ensuite? Ziggu mettra en place {project} dans un délai de 3 à 5 jours ouvrables. Vous serez averti une fois que tout sera prêt.",
        "templateProjects": "Projets de modèles",
        "unFollow": "Ne plus recevoir de notifications pour {project}",
        "underConstruction": "En cours de construction",
        "units": "Unités",
        "unitsActiveRemaining": "UNITÉS DISPONIBLES",
        "unitsAllotted": "UNITES",
        "unitsCountSubtitle": "Combien d'unités?",
        "unselected": "Cliquez pour sélectionner",
        "youAreEditingTemplateProject": "Vous modifiez un modèle de projet",
        "you_have_inbound_emails": "Vous avez 1 e-mail entrant non traité | Vous avez {number} e-mails entrants non traités"
      },
      "messages": {
        "units_count_max": "Si vous souhaitez créer d'autres unités, veuillez nous contacter via le chat. "
      },
      "modals": {
        "add_project": {
          "step_1": {
            "title": "Mettons en place votre nouveau projet !"
          },
          "step_2": {
            "title": "Ce projet contient-il une ou plusieurs unités ?"
          },
          "step_3": {
            "subtitle": "Cliquez sur les cartes pour activer les niveaux intermédiaires.",
            "title": "Vous avez besoin de niveaux intermédiaires ?"
          },
          "step_4": {
            "info": "Les modèles de décision et de formulaire peuvent être importés une fois que les unités sont créées pour ce projet.",
            "placeholder": "Sélectionnez un projet ou laissez ce champ vide si vous ne souhaitez pas copier à partir d'un modèle",
            "title": "Utiliser un modèle comme base ?"
          }
        }
      },
      "navigation": {
        "backToProjects": "Retour au projet"
      },
      "notifications": {
        "emailHasBeenCopied": "Adresse e-mail copiée avec succès",
        "pictureChangedSuccessfully": "L'image a été mise à jour. Les modifications peuvent prendre jusqu'à une heure pour être visibles.",
        "tokenCopied": "Token copié avec succès",
        "urlHasBeenCopied": "L'URL a été copiée avec succès"
      },
      "placeholders": {
        "employees": {
          "none": {
            "subtitle": "Vous n'avez accès à aucun projet. Demandez à un membre de l'équipe avec le rôle de Propriétaire de vous accorder l'accès.",
            "title": "Pas de projets"
          }
        },
        "partners": {
          "noProjectSubtitle": "Vous serez informé dès qu'un nouveau projet vous sera attribué",
          "noProjectTitle": "Pas encore de projet"
        }
      },
      "snackbars": {
        "duplicate": "Le processus de copie a commencé et peut prendre quelques instants. Veuillez rafraîchir la page après quelques minutes."
      },
      "sort": {
        "nameAsc": "Nom (A–Z)",
        "nameDesc": "Nom (Z–A)",
        "newest": "Plus récent d'abord",
        "oldest": "Plus ancien d'abord"
      },
      "toasts": {
        "activateSuccess": "{project_name} a été activé avec succès.",
        "deactivateSuccess": "{project_name} a été désactivé avec succès.",
        "duplicate": "Le projet est prêt, mais l'ouverture du ballon peut durer quelques minutes."
      },
      "tooltip": {
        "hasNoActiveUnits": "N'a pas d'unités actives",
        "turnOffNotifications": "Désactiver les notifications pour {project}",
        "turnOnNotifications": "Activer les notifications pour {project}"
      },
      "validation": {
        "addressInformationRequired": "Informations d'adresse requises",
        "companyNeedName": "Nom de l'entreprise requis",
        "companyNeedVatNumber": "Numéro de TVA requis",
        "dateAfter": "Date doit être apres le date de début",
        "lessThanOrEqual": "Le nombre doit être moins que ou égal à {max_number}",
        "maxLength": "Le nom peut comporter un maximum de {length} caractères",
        "nameAlreadyTaken": "Le nom est déjà pris pour ce projet",
        "needName": "Titre requis",
        "needNumber": "Besoin d'un numéro (pax example 8400.5)",
        "needUnitsCount": "Le nombre d'unités est requis"
      }
    }
  }
}
